export enum RawMaterialActionsEnum {
    CHANGE_ARTICLE = 'change_article',
    DELETE = 'delete'
}
